import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppComponent } from "./app.component";
import { APP_BASE_HREF } from "@angular/common";
import { CameraComponent } from "./share/camera/camera.component";
import { AppRoutingModule } from "./app-routing.module";
import { FrontIDComponent } from "./pages/front-id/front-id.component";
import { ScanRutComponent } from "./pages/scan-rut/scan-rut.component";
import {NgxUiLoaderConfig, NgxUiLoaderModule} from "ngx-ui-loader";
import { FrontFaceComponent } from "./pages/front-face/front-face.component";
import { SelfieComponent } from "./pages/selfie/selfie.component";
import { FinalResultComponent } from "./pages/final-result/final-result.component";
import { HttpClientModule } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import {BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {NgxImageCompressService} from "ngx-image-compress";
import { InputRutComponent } from "./pages/input-rut/input-rut.component";
import { StepperComponent } from "./pages/stepper/stepper.component"
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import "@capacitor-community/camera-preview";
import { CameraEmbedComponent } from './share/camera-embed/camera-embed.component';
import {OnlynumberDirective} from "./directives/Onlynumber";
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatIconModule} from "@angular/material/icon";
// configuraci�n de waiting
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'red',
  bgsOpacity: 0.5,
  bgsPosition: 'bottom-right',
  bgsSize: 60,
  bgsType: 'ball-spin-clockwise',
  blur: 5,
  delay: 0,
  fgsColor: '#44c9ab',
  fgsPosition: 'center-center',
  fgsSize: 70,
  fgsType: 'ball-scale-multiple',
  gap: 24,
  logoPosition: 'center-center',
  logoSize: 120,
  logoUrl: '',
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  overlayColor: 'rgba(40, 40, 40, 0.8)',
  pbColor: 'red',
  pbDirection: 'ltr',
  pbThickness: 3,
  hasProgressBar: false,
  text: '',
  textColor: '#FFFFFF',
  textPosition: 'center-center',
  maxTime: -1,
  minTime: 300
};
@NgModule({
  declarations: [
    AppComponent,
    CameraComponent,
    FrontIDComponent,
    ScanRutComponent,
    FrontFaceComponent,
    SelfieComponent,
    FinalResultComponent,
    StepperComponent,
    InputRutComponent,
    CameraEmbedComponent,
    OnlynumberDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    ReactiveFormsModule,
    FormsModule,
    MatButtonToggleModule,
    MatIconModule
  ],
  providers: [NgxImageCompressService,{provide: APP_BASE_HREF, useValue: "/idnow-app"}],
  bootstrap: [AppComponent]
})
export class AppModule { }
